module.exports = __webpack_public_path__ + "static/img/partner12.71cf57f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner12.png
// module id = Fmwf
// module chunks = 1